import { render } from "./OnBoardingRecap.vue?vue&type=template&id=73c255b2&scoped=true"
import script from "./OnBoardingRecap.vue?vue&type=script&lang=js"
export * from "./OnBoardingRecap.vue?vue&type=script&lang=js"

import "./OnBoardingRecap.vue?vue&type=style&index=0&id=73c255b2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73c255b2"]])

export default __exports__